export default __webpack_public_path__ + "static/media/fa-regular-400.0d03b1bb.ttf";